import { baseApi } from "@/redux/api/base-api";
import { IHttpResponse } from "@/types/api-response";
import {
  IGetUmrahList,
  IUmrahSearchQueryArgs,
  IUmrahSearchQueryParams,
} from "../types/umrah-search-type";
import { setUmrahForExtractFilter } from "../state/extract-umrah-filter-slice";

let lastSearchQueryArgStr: string | null = null;

function getSearchParams(arg: IUmrahSearchQueryArgs): IUmrahSearchQueryParams {
  return arg.searchParams ?? {};
}

export const umrahSearch = baseApi.injectEndpoints({
  overrideExisting: true,
  endpoints: (builder) => ({
    searchUmrah: builder.query<IHttpResponse<IGetUmrahList[]>, IUmrahSearchQueryArgs>({
      query: () => ({
        url: "/b2c/umrah",
        method: "GET",
      }),
      providesTags: ["UMRAH_SEARCH"],
      keepUnusedDataFor: 0,
      async onQueryStarted(arg, { dispatch, queryFulfilled }) {
        const currentArgStr = JSON.stringify(arg);
        const isRefresh = lastSearchQueryArgStr === currentArgStr;
        lastSearchQueryArgStr = currentArgStr;

        try {
          const { data } = await queryFulfilled;
          dispatch(
            setUmrahForExtractFilter({
              results: data?.data ?? [],
              searchParams: getSearchParams(arg),
              keepFilters: isRefresh,
            }),
          );
        } catch {
          // handled by query error state
        }
      },
      async onCacheEntryAdded(arg, { dispatch, cacheDataLoaded, getCacheEntry }) {
        try {
          await cacheDataLoaded;
          const entry = getCacheEntry();

          if (entry.status === "fulfilled") {
            const currentArgStr = JSON.stringify(arg);
            const isRefresh = lastSearchQueryArgStr === currentArgStr;
            lastSearchQueryArgStr = currentArgStr;

            dispatch(
              setUmrahForExtractFilter({
                results: entry.data?.data ?? [],
                searchParams: getSearchParams(arg),
                keepFilters: isRefresh,
              }),
            );
          }
        } catch {
          // no-op
        }
      },
    }),
  }),
});

export const { useSearchUmrahQuery } = umrahSearch;
